import React from 'react'
import {Motion, spring} from 'react-motion'

export default class RefreshBtn extends React.Component {
	static propTypes = {
		className: React.PropTypes.string,
	}
	constructor(props) {
		super(props)
		this.state = {isPressed: false, rotate: 0}
	}

	handleMouseDown() {
		this.setState({isPressed: true})
	}

	handleMouseUp() {
		const {rotate} = this.state
		this.setState({isPressed: false, rotate: rotate - 360})
	}

	render() {
		const {rotate} = this.state
		return (
			<Motion style={{rotate: spring(rotate)}}>
				{({rotate}) =>
					<div {...this.props} onMouseDown={() => this.handleMouseDown()} onMouseUp={() => this.handleMouseUp()} className={`refreshButton ${this.props.className || ''}`}>
						<div className="iconContainer" style={{transform: `rotate(${rotate}deg)`}}>
							<img src={require('resources/icn-refresh.svg')}/>
						</div>
					</div>
				}
			</Motion>)
	}
}



// WEBPACK FOOTER //
// ./components/refreshBtn.jsx